import { PortableText, PortableTextComponents, SanityAssetDocument } from 'next-sanity'
import { PortableTextObject } from 'sanity'
import { styles, InvestorsVariants } from './Investors.css'
import { InvestorCard } from '../InvestorCard'
import { SectionHeader } from '@otomoro/components/shared/SectionHeader'
import { SanityImage } from '@otomoro/components/shared/SanityImage'
import { Tag } from '@otomoro/components/shared/Tag'
import { AppTitle } from '@otomoro/components/shared/AppTitle'

interface InvestorsProps extends InvestorsVariants {
	tag: string
	title: PortableTextObject
	investors: {
		_id: string
		image: SanityAssetDocument
	}[]
}

export const Investors: React.FC<InvestorsProps> = ({ tag, title, investors }) => {
	const { wrapper, base } = styles()
	const components = {
		block: {
			normal: ({ children }: any) => (
				<AppTitle as="h2" textTransform="uppercase" className="mt-1" color="black">
					{children}
				</AppTitle>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

	return (
		<div className={wrapper()}>
			<section className={base()}>
				<header className="shrink-0">
					<Tag as="strong" className="" theme="light">
						{tag}
					</Tag>
					<PortableText value={title} components={components} />
				</header>
				<div className="grid grid-cols-2 gap-x-[0.75rem] md:gap-x-2 w-full lg:max-w-[61.6%]">
					{investors.map((investor) => (
						<div
							key={investor._id}
							className="bg-white border-2 border-black rounded-[8px] md:rounded-l flex justify-center items-center py-[1.4rem] md:py-0 md:h-[17rem] shrink-0"
						>
							<SanityImage
								figureClass="w-[55%]"
								className="w-full h-full object-contain"
								image={investor.image.image}
								alt=""
								width={investor.image.width}
								height={investor.image.height}
							/>
						</div>
					))}
				</div>
			</section>
		</div>
	)
}
